import { render, staticRenderFns } from "./paul-jaboulet-aine.vue?vue&type=template&id=97cba468&scoped=true"
import script from "./paul-jaboulet-aine.vue?vue&type=script&lang=js"
export * from "./paul-jaboulet-aine.vue?vue&type=script&lang=js"
import style0 from "./paul-jaboulet-aine.vue?vue&type=style&index=0&id=97cba468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cba468",
  null
  
)

export default component.exports